import React from "react";
import { StyleSheet } from "react-native";
import { styleConstants as C } from "~/style/styleConstants";
import { View } from "./View";
import type { ViewStyle } from "react-native";

export interface DividerProps {
  vertical?: boolean;
  style?: ViewStyle | undefined;
}

const S = StyleSheet.create({
  verticalDivider: {
    width: StyleSheet.hairlineWidth,
    height: "100%",
    backgroundColor: C.colorBackgroundDisabled,
  },
  horizontalDivider: {
    height: StyleSheet.hairlineWidth,
    width: "100%",
    backgroundColor: C.colorBackgroundDisabled,
  },
});

export function Divider({ vertical, style }: DividerProps) {
  return (
    <View style={[vertical ? S.verticalDivider : S.horizontalDivider, style]} />
  );
}
